import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '/',
        meta: {
          menuIndex: '1'
        },
        component: () => import('@/views/LandingPage.vue')
      },
      {
        path: '/landingPage',
        name: 'landingPage',
        meta: {
          menuIndex: '1'
        },
        component: () => import('@/views/LandingPage.vue')
      },
      {
        path: '/timeTable',
        name: 'timeTable',
        meta: {
          menuIndex: '1-1'
        },
        component: () => import('@/views/aboutExh/timeTable.vue')
      },
      {
        path: '/location',
        name: 'location',
        meta: {
          menuIndex: '1-2'
        },
        component: () => import('@/views/aboutExh/location.vue')
      },
      {
        path: '/serve',
        name: 'serve',
        meta: {
          menuIndex: '1-3'
        },
        component: () => import('@/views/aboutExh/serve.vue')
      },
      {
        path: '/remittance',
        name: 'remittance',
        meta: {
          menuIndex: '1-4'
        },
        component: () => import('@/views/aboutExh/remittance.vue')
      },
      {
        path: '/require',
        name: 'require',
        meta: {
          menuIndex: '1-5'
        },
        component: () => import('@/views/aboutExh/require.vue')
      },
      {
        path: '/planView',
        name: 'planView',
        meta: {
          menuIndex: '1-6'
        },
        component: () => import('@/views/aboutExh/planView.vue')
      },
      {
        path: '/magezine',
        name: 'magezine',
        meta: {
          menuIndex: '2-1'
        },
        component: () => import('@/views/MagezineInfo.vue')
      },
      {
        path: '/card',
        name: 'card',
        meta: {
          menuIndex: '2-2'
        },
        component: () => import('@/views/card/Card.vue')
      },
      {
        path: '/boardInfo',
        name: 'boardInfo',
        meta: {
          menuIndex: '2-3'
        },
        component: () => import('@/views/board/boardInfo.vue')
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        meta: {
          menuIndex: '2-4'
        },
        component: () => import('@/views/service/knowledge.vue')
      },
      {
        path: '/sound',
        name: 'sound',
        meta: {
          menuIndex: '2-5'
        },
        component: () => import('@/views/service/sound.vue')
      },
      {
        path: '/tableDownload',
        name: 'tableDownload',
        meta: {
          menuIndex: '2-6'
        },
        component: () => import('@/views/service/tableDownload.vue')
      },
      {
        path: '/advertisement',
        name: 'advertisement',
        meta: {
          menuIndex: '3-1'
        },
        component: () => import('@/views/advertisement/advertisement.vue')
      },
      {
        path: '/onlinemagezine',
        name: 'onlinemagezine',
        meta: {
          menuIndex: '4-1'
        },
        component: () => import('@/views/OnlineMagezineInfo.vue')
      },
      {
        path: '/product',
        name: 'product',
        meta: {
          menuIndex: '4-2'
        },
        component: () => import('@/views/product/Product.vue')
      },
//    {
//      path: '/advertisement',
//      name: 'advertisement',
//      meta: {
//        menuIndex: '4-3'
//      },
//      component: () => import('@/views/advertisement/advertisement.vue')
//    },
      {
        path: '/resetPass',
        name: 'resetPass',
        meta: {
          menuIndex: '6-1'
        },
        component: () => import('@/views/other/resetPass.vue')
      },
      {
        path: '/downzssc',
        name: 'downzssc',
        meta: {
          menuIndex: '6-2'
        },
        component: () => import('@/views/other/downzssc.vue')
      },
      {
        path: '/buildingService',
        name: 'buildingService',
        meta: {
          menuIndex: '7-1'
        },
        component: () => import('@/views/guide/buildingService.vue')
      },
      {
        path: '/buildingGuide',
        name: 'buildingGuide',
        meta: {
          menuIndex: '7-2'
        },
        component: () => import('@/views/guide/buildingGuide.vue')
      },
      {
        path: '/inviteVIP',
        name: 'inviteVIP',
        meta: {
          menuIndex: '8-1'
        },
        component: () => import('@/views/invite/inviteVIP.vue')
      },
      {
        path: '/inviteFree',
        name: 'inviteFree',
        meta: {
          menuIndex: '8-2'
        },
        component: () => import('@/views/invite/inviteFree.vue')
      },
      {
        path: '/addVIP',
        name: 'addVIP',
        meta: {
          menuIndex: '8-3'
        },
        component: () => import('@/views/invite/addVIP.vue')
      },
      {
        path: '/addzygz',
        name: 'addzygz',
        meta: {
          menuIndex: '8-4'
        },
        component: () => import('@/views/invite/addzygz.vue')
      },
      {
        path: '/inviteCodeEmail',
        name: 'inviteCodeEmail',
        meta: {
          menuIndex: '9'
        },
        component: () => import('@/views/board/inviteCodeEmail.vue')
      },
      {
        path: '/hotel',
        name: 'hotel',
        meta: {
          menuIndex: '10'
        },
        component: () => import('@/views/board/hotel.vue')
      },
      {
        path: '/downCenter',
        name: 'downCenter',
        meta: {
          menuIndex: '12'
        },
        component: () => import('@/views/downCenter.vue')
      },
      {
        path: '/reservation',
        name: 'reservation',
        meta: {
          menuIndex: '1-2'
        },
        component: () => import('@/views/Reservation.vue')
      },
      
      {
        path: '/company',
        name: 'company',
        meta: {
          menuIndex: '2-1'
        },
        component: () => import('@/views/companyInfo.vue')
      },
      {
        path: '/product',
        name: 'product',
        meta: {
          menuIndex: '2-3'
        },
        component: () => import('@/views/product/Product.vue')
      },
      {
        path: '/addProduct',
        name: 'addProduct',
        meta: {
          menuIndex: '2-3'
        },
        component: () => import('@/views/product/AddProduct.vue')
      },
      {
        path: '/catalog',
        name: 'catalog',
        component: () => import('@/views/company/catalog.vue')
      },
      {
        path: '/tz',
        name: 'tz',
        meta: {
          menuIndex: '3-2'
        },
        component: () => import('@/views/board/tz.vue')
      },

      {
        path: '/electric',
        name: 'electric',
        meta: {
          menuIndex: '3-3'
        },
        component: () => import('@/views/board/electric.vue')
      },
      {
        path: '/exhibition',
        name: 'exhibition',
        meta: {
          menuIndex: '3-4'
        },
        component: () => import('@/views/board/exhibition.vue')
      },
      {
        path: '/lzCode',
        name: 'LzCode',
        meta: {
          menuIndex: '7'
        },
        component: () => import('@/views/lzCode/index.vue')
      },
      {
        path: '/addCard',
        name: 'addCard',
        meta: {
          menuIndex: '4'
        },
        component: () => import('@/views/card/AddCard.vue')
      },
      {
        path: '/activityList',
        name: 'activityList',
        meta: {
          menuIndex: '5'
        },
        component: () => import('@/views/active/activityList.vue')
      },
      {
        path: '/activityList/edit',
        name: 'activityEdit',
        meta: {
          menuIndex: '5'
        },
        component: () => import('@/views/active/edit.vue')
      },
      {
        path: '/adBook',
        name: 'adBook',
        meta: {
          menuIndex: '6-1'
        },
        component: () => import('@/views/service/adBook.vue')
      },
      {
        path: '/fshow',
        name: 'fshow',
        meta: {
          menuIndex: '6-2'
        },
        component: () => import('@/views/service/fshow.vue')
      },
      {
        path: '/inviteCode',
        name: 'inviteCode',
        meta: {
          menuIndex: '8'
        },
        component: () => import('@/views/board/inviteCode.vue')
      },
      {
        path: '/yaoqing',
        name: 'yaoqing',
        meta: {
          menuIndex: '13'
        },
        component: () => import('@/views/board/yaoqing.vue')
      },
      {
        path: '/boothBook',
        name: 'boothBook',
        meta: {
          menuIndex: '14'
        },
        component: () => import('@/views/boothBook.vue')
      },

    ]
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue')
  },
  {
    path: '/login',
    name: 'login',
    props: true,
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/singUp',
    name: 'singUp',
    component: () => import('@/views/singUp.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
